// Auto-generated by scripts/generate-messages.mjs — do not edit manually
export const MESSAGE_DEFAULTS: Record<string, string> = {
    "add/loading": "Loading…",
    "add/locations-error": "Cannot load locations.",
    "app/install-banner": "Install Pantry Pal on this device",
    "app/install-hint": "Install: Chrome menu (⋮) → Install app, or Add to Home screen",
    "app/server-unreachable": "Cannot reach pantry server",
    "auth/login-failed": "Wrong username or password. Try again.",
    "auth/login-hint": "Sign in with your username and password.",
    "auth/login-password": "Password",
    "auth/login-submit": "Sign in",
    "auth/login-title": "Sign in to Pantry Pal",
    "auth/register-hint": "Pick a username and a password (8+ characters).",
    "auth/register-submit": "Create account",
    "auth/register-title": "Create your Pantry Pal account",
    "auth/switch-to-login": "Have an account? Sign in",
    "auth/switch-to-register": "New here? Create an account",
    "auth/username-taken": "That username is taken. Try another.",
    "auth/username": "Username",
    "dashboard/hit-list-empty": "Nothing on the hit list. Suspicious.",
    "dashboard/hit-list-no-data": "No data.",
    "dashboard/hit-list-section-title": "The Hit List",
    "dashboard/recipe-cta": "VIEW RECIPE →",
    "dashboard/recipe-empty": "Nothing in stock to cook with right now.",
    "dashboard/recipe-loading": "Loading recipe…",
    "dashboard/recipe-section-title": "Use It Or Lose It",
    "dashboard/recipe-server-offline": "Server offline.",
    "dashboard/server-unreachable": "Cannot reach the pantry server. Fix that first.",
    "dashboard/spin-failed": "Failed to spin recipe",
    "dashboard/vitals-expired": "expired",
    "dashboard/vitals-expiring-soon": "expiring soon",
    "dashboard/vitals-in-stock": "stocked",
    "dashboard/vitals-to-buy": "to buy",
    "edit/header": "Modify scanned item — update any details or delete",
    "edit/load-error": "Cannot load item.",
    "edit/loading": "Loading item…",
    "grocery/empty-hint": "Add items manually or link pantry stock for auto-restock alerts.",
    "grocery/empty": "Your list is empty.",
    "grocery/load-error": "Cannot load grocery list.",
    "grocery/loading": "Loading grocery list…",
    "grocery/restock-apply": "MOVE TO TO BUY",
    "grocery/restock-lower-hint": "Sets quantity below the restock minimum ({{min}})",
    "grocery/restock-lower": "Lower pantry stock to {{qty}}",
    "grocery/restock-raise-hint": "One above current stock ({{qty}})",
    "grocery/restock-raise-label": "New minimum",
    "grocery/restock-raise": "Raise minimum to {{min}}",
    "grocery/restock-title": "Need {{name}} again?",
    "grocery/subtitle-many": "{{count}} items to pick up",
    "grocery/subtitle-none": "Nothing to buy right now",
    "grocery/subtitle-one": "1 item to pick up",
    "grocery-link/match-kind-auto": "unlinked auto-restock rule",
    "grocery-link/match-kind-manual": "manual list item",
    "grocery-link/similar-prompt": "«{{itemName}}» looks similar to «{{matchName}}» ({{matchKind}}) on your grocery list.",
    "locations/empty": "No zones yet.",
    "locations/load-error": "Cannot load locations.",
    "locations/loading": "Loading zones…",
    "pantry/load-error": "Cannot load inventory. Is the server running?",
    "pantry/loading": "Loading inventory…",
    "pantry/no-items": "No items found.",
    "recipe-sheet/expired-prefix": "Expired: {{label}}",
    "recipe-sheet/expiring-prefix": "Expires soon: {{label}}",
    "scan/camera-unavailable": "Camera unavailable — use manual entry",
    "scan/find-loading": "Finding item…",
    "scan/https-body": "Camera access requires a secure context (HTTPS or localhost).\n\nIf you're accessing this from another device, use an HTTPS reverse proxy or tunnel.",
    "scan/https-title": "HTTPS required for camera access",
    "scan/https-toast": "Camera needs HTTPS — see instructions above",
    "scan/loading-camera": "Starting camera…",
    "scan/lookup-failed": "Lookup failed",
    "scan/lookup-loading": "Looking up product…",
    "scan/no-barcode-match": "No item with barcode {{upc}}",
    "scan/no-inventory-match": "No matching item in inventory",
    "toast/added-item": "Added {{name}}",
    "toast/added-to-grocery": "Added to grocery list",
    "toast/cannot-delete-zone": "This zone still has items in it, so it can't be deleted. Move or remove them first.",
    "toast/choose-location": "Choose a location",
    "toast/enter-name": "Enter a name",
    "toast/failed-add-inventory-item": "Failed to add item",
    "toast/failed-add-item": "Failed to add item",
    "toast/failed-link-grocery": "Failed to link grocery item",
    "toast/failed-remove-item": "Failed to remove item",
    "toast/failed-reorder": "Failed to reorder",
    "toast/failed-save": "Failed to save",
    "toast/failed-spin-recipe": "Failed to spin recipe",
    "toast/failed-update-grocery": "Failed to update grocery list",
    "toast/failed-update-quantity": "Failed to update quantity",
    "toast/image-upload-failed": "Image upload failed",
    "toast/invalid-minimum": "Enter a minimum above current stock ({{qty}})",
    "toast/item-updated": "Item updated",
    "toast/linked-auto-restock": "Linked {{name}} for auto-restock",
    "toast/linked-pantry-stock": "Linked {{name}} to pantry stock",
    "toast/moved-to-buy": "{{name}} moved to To Buy",
    "toast/removed-from-grocery": "Removed {{name}} from grocery list",
    "toast/removed": "Removed {{name}}",
    "toast/restored": "Restored {{name}}",
    "toast/select-inventory-item": "Select an inventory item",
    "toast/stocked": "Stocked {{name}}",
    "toast/zone-created": "Zone created",
    "toast/zone-updated": "Zone updated"
};
